import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isFetching: false,
  isAuthenticated: false,
  hasAgreedTermsOfService: true,
  accessToken: '',
  idToken: '',
  userInfo: {
    username: '',
    id: '',
    email: '',
    privilege: '',
    name: '',
    termsOfServiceAgreed: null,
    tenantId: '',
    phone: '',
    mfaSettings: [],
    mfaEnabled: '',
  },
  addonControls: {
    _id: null,
    tenant: '',
    collaborationActivated: false,
    engagementLogActivated: false,
    trackerAIActivated: false,
  },
  broadcastPopup: {
    seen: true,
    content: '',
  },
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setIsFetching: (state) => {
      state.isFetching = true;
      state.isAuthenticated = false;
    },
    setIsAuthenticated: (state) => {
      state.isAuthenticated = true;
      state.isFetching = false;
    },
    userLogout: (state) => {
      state.isFetching = false;
      state.isAuthenticated = false;
      state.hasAgreedTermsOfService = true;
      state.accessToken = '';
      state.idToken = '';
      state.userInfo = {
        username: '',
        id: '',
        email: '',
        privilege: '',
        name: '',
        termsOfServiceAgreed: null,
        tenantId: '',
        phone: '',
      };
      state.addonControls = {
        _id: null,
        tenant: '',
        collaborationActivated: false,
        engagementLogActivated: false,
        trackerAIActivated: false,
      };
      state.broadcastPopup = {
        seen: true,
        content: '',
      };
    },
    setUserInfo: (state, action) => {
      state.userInfo = action.payload;
    },
    setUserNonPIUserSettings: (state, action) => {
      if (state.userInfo) {
        state.userInfo.nonPIUserSettings = action.payload;
      }
    },
    setUserStoredFilters: (state, action) => {
      if (state.userInfo?.nonPIUserSettings) {
        state.userInfo.nonPIUserSettings.userStoredFilters = {
          ...state.userInfo.nonPIUserSettings.userStoredFilters,
          ...action.payload,
        };
      } else if (state.userInfo) {
        state.userInfo = {
          nonPIUserSettings: action.payload,
        };
      }
    },
    setUserHasAgreedAgreedTermsOfService: (state, action) => {
      state.hasAgreedTermsOfService = action.payload;
    },
    setUserAddonPageAccessControls: (state, action) => {
      if (action.payload) {
        state.addonControls = action.payload;
      }
    },
    setUserBroadcastPopup: (state, action) => {
      if (action.payload) {
        state.broadcastPopup = action.payload;
      }
    },
    setAccessToken: (state, action) => {
      state.accessToken = action.payload || '';
    },
    setIdToken: (state, action) => {
      state.idToken = action.payload || '';
    },
  },
});

export const {
  setIsFetching,
  setIsAuthenticated,
  userLogout,
  setUserInfo,
  setUserNonPIUserSettings,
  setUserStoredFilters,
  setUserHasAgreedAgreedTermsOfService,
  setUserAddonPageAccessControls,
  setUserBroadcastPopup,
  setAccessToken,
  setIdToken,
} = userSlice.actions;

export default userSlice.reducer;
